import { defineStore } from 'pinia'
import { ref } from '@nuxtjs/composition-api'
import { getUser, receivingBonuses, getUserIikoCard, receivingBonusesIikoCard } from './../api'
import { AxiosError } from 'axios'

export const useLoyaltyModel = defineStore('loyalty', () => {
  const bonusesWrittenOff = ref<number>(0) // количество бонусов PrimeHill для списания
  const totalNumberBonuses = ref<number>(0) // количество бонусов PrimeHill
  const userNameGreeting = ref<string>('') // приветствие
  const typeWriteOffBonuses = ref<string>('') // тип списания бонусов PrimeHill
  const verification = ref<'ON' | 'OFF' | ''>('') // необходимость верификации кодом
  const currentPhone = ref<string>('') // текущий телефон в loyalty flow
  const verifiedPhone = ref<string>('') // телефон, подтвержденный кодом на устройстве
  const loyaltyBarcode = ref<string>('') // barcode пользователя из get-user
  const sumDiscountPrimeHill = ref<number>(0) // скидка PrimeHill
  const creditedBonusesPrimeHill = ref<number>(0) // количество зачисляемых бонусов PrimeHill
  const normalizeVerification = (value: unknown): 'ON' | 'OFF' => {
    if (value === true || value === 1) {
      return 'ON'
    }
    if (value === false || value === 0 || value === null || value === undefined) {
      return 'OFF'
    }

    const normalized = String(value).trim().toUpperCase()
    if (['ON', 'TRUE', '1', 'YES', 'Y'].includes(normalized)) {
      return 'ON'
    }

    return 'OFF'
  }

  const fetchUserPrimeHill = async (payload: { tel: string; session: number }) => {
    const { tel, session } = payload
    try {
      const res = await getUser(tel, session)
      currentPhone.value = tel
      loyaltyBarcode.value = String(res.barcode ?? res.cardNumber ?? '')
      bonusesWrittenOff.value = res.maxBonus / 100
      totalNumberBonuses.value = res.bonusBalance / 100
      userNameGreeting.value = res.firstName
      typeWriteOffBonuses.value = res.typeWriteOff
      verification.value = normalizeVerification(res.verification)
      sumDiscountPrimeHill.value = res.sumDiscount / 100
      return true
    } catch (e) {
      const error = e as AxiosError
      // eslint-disable-next-line no-console
      console.log(error.response?.data)

      return false
    }
  }

  const fetchUserBalanceBonus = async (transactionId: number) => {
    try {
      const { balance } = await receivingBonuses(transactionId)
      creditedBonusesPrimeHill.value = balance
      return true
    } catch (e) {
      const error = e as AxiosError
      // eslint-disable-next-line no-console
      console.log(error.response?.data)

      return false
    }
  }
  // iicoCard
  const fetchUserIikoCard = async (payload: { tel: string; session: number }) => {
    const { tel, session } = payload
    try {
      const res = await getUserIikoCard(tel, session)
      currentPhone.value = tel
      loyaltyBarcode.value = String(res.barcode ?? res.cardNumber ?? '')
      bonusesWrittenOff.value = res.maxBonus / 100
      totalNumberBonuses.value = res.bonusBalance / 100
      userNameGreeting.value = res.firstName
      typeWriteOffBonuses.value = res.typeWriteOff
      verification.value = normalizeVerification(res.verification)
      sumDiscountPrimeHill.value = res.sumDiscount / 100
      return true
    } catch (e) {
      const error = e as AxiosError
      // eslint-disable-next-line no-console
      console.log(error.response?.data)

      return false
    }
  }
  const fetchUserBalanceBonusIikoCard = async (transactionId: number) => {
    try {
      const { balance } = await receivingBonusesIikoCard(transactionId)
      creditedBonusesPrimeHill.value = balance
      return true
    } catch (e) {
      const error = e as AxiosError
      // eslint-disable-next-line no-console
      console.log(error.response?.data)

      return false
    }
  }

  const setCurrentPhone = (phone: string) => {
    currentPhone.value = phone
  }

  const setVerifiedPhone = (phone: string) => {
    verifiedPhone.value = phone
  }

  return {
    bonusesWrittenOff,
    totalNumberBonuses,
    userNameGreeting,
    typeWriteOffBonuses,
    verification,
    currentPhone,
    verifiedPhone,
    loyaltyBarcode,
    sumDiscountPrimeHill,
    creditedBonusesPrimeHill,
    setCurrentPhone,
    setVerifiedPhone,
    fetchUserPrimeHill,
    fetchUserBalanceBonus,
    fetchUserIikoCard,
    fetchUserBalanceBonusIikoCard
  }
})
